module.exports = __webpack_public_path__ + "img/notAllowed.9f784077.png";